import { render, staticRenderFns } from "./zspPallet.vue?vue&type=template&id=2950ece8&scoped=true"
import script from "./zspPallet.vue?vue&type=script&lang=js"
export * from "./zspPallet.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2950ece8",
  null
  
)

export default component.exports